import {MtplContract} from "./contract";
import {CascoAdditionalCoverage, VtplAdditionalCoverage} from "./additionalCoverage";
import {IAdditionalPerson} from "../pages/TravelQuotationForm/AdditinalPerson";

export enum QuotationStatus {
	TARIFFICATION = "TARIFFICATION",
	DRAFT = "DRAFT",
	VALIDATED = "VALIDATED",
	SIGNED = "SIGNED",
	ANNULATED = "ANNULATED"
}

export enum TripsCount {
	TRAVEL = 'TRAVEL',
	MULTI_TRAVEL = 'MULTI_TRAVEL'
}

export enum TravelArea {
	ALL_EXCEPT_THE_US_CANADA_INDONESIA_THAILAND_AND_INDIA = 'ALL_EXCEPT_THE_US_CANADA_INDONESIA_THAILAND_AND_INDIA',
	ALL_EXCEPT_THE_US_AND_CANADA = 'ALL_EXCEPT_THE_US_AND_CANADA',
	EUROPE_CIS_TURKEY_TUNISIA_EGYPT = 'EUROPE_CIS_TURKEY_TUNISIA_EGYPT',
	ALL = 'ALL'
}

export enum AgeOfInsured {
	FROM_1_TO_75 = 'FROM_1_TO_75',
	FROM_18_TO_59 = 'FROM_18_TO_59'
}

export enum TravelPackage {
	CLASSIC = 'CLASSIC',
	OPTIMAL = 'OPTIMAL',
	PREMIUM = 'PREMIUM'
}

export enum TravelPurpose {
	TOURISM = 'TOURISM',
	WORK = 'WORK',
	SPORT = 'SPORT',
	TOURISM_WITHOUT_AR = 'TOURISM_WITHOUT_AR',
	WORK_WITHOUT_AR = 'WORK_WITHOUT_AR'
}

export const quotationStatusList = [QuotationStatus.TARIFFICATION, QuotationStatus.DRAFT, QuotationStatus.VALIDATED, QuotationStatus.SIGNED, QuotationStatus.ANNULATED];

export const tripsCount = [TripsCount.TRAVEL, TripsCount.MULTI_TRAVEL];

export const travelArea = [TravelArea.ALL_EXCEPT_THE_US_CANADA_INDONESIA_THAILAND_AND_INDIA, TravelArea.ALL_EXCEPT_THE_US_AND_CANADA, TravelArea.EUROPE_CIS_TURKEY_TUNISIA_EGYPT, TravelArea.ALL];

export const ageOfInsured = [AgeOfInsured.FROM_1_TO_75, AgeOfInsured.FROM_18_TO_59];

export const travelPackage = [TravelPackage.CLASSIC, TravelPackage.OPTIMAL, TravelPackage.PREMIUM];

export const travelPurpose = [TravelPurpose.TOURISM, TravelPurpose.WORK, TravelPurpose.SPORT, TravelPurpose.TOURISM_WITHOUT_AR, TravelPurpose.WORK_WITHOUT_AR];

export interface ITravelWebPerson {
	id: string
	residentCountry: string
	surname: string
	givenName: string
	middleName: string
	birthDate: string
	mobileNumber: string
	documentNumber: string
	travelPurpose: string // TravelPurpose
}

export interface LivingAddress {
	unstructured: string
}

export interface ResidentCountry {
	code: string
	name: string
}

interface IRegistrationDocument {
	documentType: 'IPN_REGISTRATION' | 'PASSPORT' | 'TRAVELLING_PASSPORT' | 'DRIVER_LICENSE'
	number: string
	issueOrganization: string
	issueDate: string
}

export interface IPrimaryInsured {
	partyType: 'PERSON' | 'PRIVATE_ENTREPRENEUR' | 'ORGANIZATION'
	resident: boolean
	residentCountry: string
	mobileNumber: string
	email: string
	registrationDocument: IRegistrationDocument
	ipn: string
	surname: string
	givenName: string
	middleName: string
	birthDate: string
	livingAddress: LivingAddress
	// documentNumber?: string
}

export interface ITravelWebContract {
	id: string
	startDate: string
	endDate: string
	sumInsured: number
	tripsCount: string // TripsCount
	touristCount: number
	primaryInsured: IPrimaryInsured
	premium: number
	travelArea: string // TravelArea
	ageOfInsured: string // AgeOfInsured
	travelPackage: "OPTIMAL" | "CLASSIC" | "PREMIUM" | null // TravelPackage
	persons: ITravelWebPerson[]
	payerIsPerson: boolean
}

export interface Quotation {
	id: string;
	creationDate: Date;
	status: string;
	currentStep: string;
	salesVariant: string;
	totalPremium: number;

	admitadId?: string;
	salesDoublerId?: string;
	messageList?: Array<string>;
}

export interface MtplQuotation extends Quotation {
	mtplContract: MtplContract;
	vtplAdditionalCoverage: VtplAdditionalCoverage;
	cascoAdditionalCoverage: CascoAdditionalCoverage;
}

export interface TravelQuotation extends Quotation {
	travelWebContract: ITravelWebContract
}

export interface ITravelWebTarriffiedPackage {
	sumInsured: number
	package: string // TravelPackage
	premium: number
}